//@flow
import React from "react"
import { IntlProvider } from "react-intl"
import { connect } from "react-redux"
import { currentLocale } from "./redux"
import messages from "./messages"
import flattenMessages from "./flattenMessages"

type Props = {
  locale: string,
  children: React$Element<any>
}

const ConnectedIntlProvider = ({ locale, children }: Props) =>
  <IntlProvider locale={locale} messages={flattenMessages(messages[locale])}>
    {children}
  </IntlProvider>

export default connect(state => ({ locale: currentLocale(state) }), null)(
  ConnectedIntlProvider
)



// WEBPACK FOOTER //
// ./src/Intl/ConnectedIntlProvider.js